import { defineComponent as _defineComponent } from 'vue'
import '@patsnap-ui/icon/assets/solid/ArrowLeft.svg';
import { useFamilySearchPage } from '@/composables/use-family-search-page';


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilySearchHeaderToggle',
  setup(__props) {

const { index, total, disabledPre, disabledNext, togglePre, toggleNext } = useFamilySearchPage();

return { __sfc: true,index, total, disabledPre, disabledNext, togglePre, toggleNext }
}

})